import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=ec0987fa&scoped=true&"
import script from "./Partners.vue?vue&type=script&lang=ts&"
export * from "./Partners.vue?vue&type=script&lang=ts&"
import style0 from "./Partners.vue?vue&type=style&index=0&id=ec0987fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0987fa",
  null
  
)

export default component.exports